export const TRANSLATIONS = {
  DESTROY_RECEIVER_SUCCESS: (fullName: string) =>
    `Successfully removed ${fullName}`,
  DESTROY_RECEIVER_ERROR: 'Error while deleting the receiver',
  DESTROY_RECEIVER_TITLE: 'Delete receiver?',
  ARE_YOU_SURE:
    "This receiver will be removed from your contact list and cannot be restored. To recreate, you'll need to save the receiver details again during the manual payout creation process",
  SOMETHING_WENT_WRONG: 'Something went wrong',
  DETAILS: 'Details',
  YES: 'Yes, delete receiver',
  NO: 'No, keep it'
};

export const ATTRIBUTES_TO_SHOW = [
  'full_name',
  'birthdate',
  'address_lines',
  'postcode',
  'city',
  'country_code',
  'created_by',
  'email',
  'mobile_number',
  'creditor_details'
];
